export const PatientSurgeryProcedureInfoCard = ({ patientSurgery }) => {
  // Datos del hook ----------------------------------------//
  const { procedure } = patientSurgery;
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <div className="card border shadow">
      <div className="card-body">
        <div className="vstack gap-2">
          <p className="mb-0">
            <strong>Procedimiento:</strong> {procedure.procedure.title}
          </p>
          <p className="mb-0">
            <strong>Propósito:</strong> {procedure.title}
          </p>
          <p className="mb-0">
            <strong>Descripción:</strong> {patientSurgery.description}
          </p>
        </div>
      </div>
    </div>
  );
};
